export default function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/hierarchy/eachAfter.js
// module id = 725
// module chunks = 0